module.exports = require("shortid");


//////////////////
// WEBPACK FOOTER
// external "shortid"
// module id = 285
// module chunks = 0